import { gql } from "@apollo/client";
import { ApolloClientQuery } from "./_setup";

const CHALLENGE_FIELDS = `
    challengeId
    method
    destinationMasked
    expiresAt
    attemptsRemaining
    resendAvailableAt
    requiresDelivery
    options
    availableMethods
    trustDeviceDays
`;

const REQUEST_TWO_FACTOR_CHALLENGE = gql`
    mutation requestTwoFactorChallenge($input: RequestTwoFactorChallengeInput!) {
        requestTwoFactorChallenge(input: $input) {
            ... on TwoFactorChallengePayload {
                ${CHALLENGE_FIELDS}
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function requestTwoFactorChallengeMutation(input) {
    return await ApolloClientQuery(REQUEST_TWO_FACTOR_CHALLENGE, { input }, true);
}

const VERIFY_TWO_FACTOR_CHALLENGE = gql`
    mutation verifyTwoFactorChallenge($input: VerifyTwoFactorChallengeInput!) {
        verifyTwoFactorChallenge(input: $input) {
            ... on TwoFactorVerifyPayload {
                challengeId
                status
                verifiedAt
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function verifyTwoFactorChallengeMutation(input) {
    return await ApolloClientQuery(VERIFY_TWO_FACTOR_CHALLENGE, { input }, true);
}

// the capture page reports to the verification service, not to us, so the verdict is asked
// for until it settles rather than submitted
const POLL_TWO_FACTOR_CHALLENGE = gql`
    mutation pollTwoFactorChallenge($input: PollTwoFactorChallengeInput!) {
        pollTwoFactorChallenge(input: $input) {
            ... on TwoFactorVerifyPayload {
                challengeId
                status
                verifiedAt
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function pollTwoFactorChallengeMutation(input) {
    return await ApolloClientQuery(POLL_TWO_FACTOR_CHALLENGE, { input }, true);
}

const RESEND_TWO_FACTOR_CHALLENGE = gql`
    mutation resendTwoFactorChallenge($input: ResendTwoFactorChallengeInput!) {
        resendTwoFactorChallenge(input: $input) {
            ... on TwoFactorChallengePayload {
                ${CHALLENGE_FIELDS}
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function resendTwoFactorChallengeMutation(input) {
    return await ApolloClientQuery(RESEND_TWO_FACTOR_CHALLENGE, { input }, true);
}

const SWITCH_TWO_FACTOR_CHALLENGE_METHOD = gql`
    mutation switchTwoFactorChallengeMethod($input: SwitchTwoFactorChallengeMethodInput!) {
        switchTwoFactorChallengeMethod(input: $input) {
            ... on TwoFactorChallengePayload {
                ${CHALLENGE_FIELDS}
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function switchTwoFactorChallengeMethodMutation(input) {
    return await ApolloClientQuery(SWITCH_TWO_FACTOR_CHALLENGE_METHOD, { input }, true);
}

// the capture url is spent once opened, so a retry asks for a fresh one rather than
// reopening the link the challenge was raised with
const RESTART_LIVENESS_CHALLENGE = gql`
    mutation restartLivenessChallenge($input: PollTwoFactorChallengeInput!) {
        restartLivenessChallenge(input: $input) {
            ... on LivenessRestartPayload {
                challengeId
                options
                expiresAt
                attemptsRemaining
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function restartLivenessChallengeMutation(input) {
    return await ApolloClientQuery(RESTART_LIVENESS_CHALLENGE, { input }, true);
}
